module.exports = __webpack_public_path__ + "img/amazons_hall_small.759e0c59.png";